<p-dialog
    *ngIf="viewModel$ | async as viewModel"
    header="Add Location Manually"
    appendTo="body"
    [visible]="viewModel.visible"
    [modal]="true"
    [style]="{width: '50vw'}"
    [breakpoints]="{'992px': '62vw', '510px': '93vw'}"
    [draggable]="false"
    [resizable]="false"
    (visibleChange)="store.dispatch(actions.closeDialogButtonClicked())"
>
    <p-message
        severity="info"
        text="Google does not recognize this exact address. Please enter the address manually"
        *ngIf="viewModel.showAddressNotRecognizedWarning"
    ></p-message>
    <br>
    <br>
    <div *ngIf="viewModel.visible"> 
        <div>
            <h6>Address</h6>
            <div class="p-grid">
                <div
                    class="p-col-3"
                >
                    <label>Number</label>
                    <br />
                    <input
                        type="text"
                        pInputText
                        class="full-width"
                        placeholder="1234 *"
                        [ngModel]="viewModel.streetNumber"
                        #streetNumber="ngModel"
                        (ngModelChange)="store.dispatch(actions.streetNumberInputChanged({
                            streetNumber: $event
                        }))"
                        required
                        [class.p-invalid-input]="streetNumber.invalid && streetNumber.touched"
                    >
                    <small class="field-error-message" *ngIf="streetNumber.invalid && streetNumber.touched">
                        Street number is required.
                    </small>
                </div>
                <div
                    class="p-col-9"
                >
                    <label>Street Name</label>
                    <br />
                    <input
                        type="text"
                        pInputText
                        class="full-width"
                        placeholder="Example Avenue *"
                        [ngModel]="viewModel.streetName"
                        #streetName="ngModel"
                        (ngModelChange)="store.dispatch(actions.streetNameInputChanged({
                            streetName: $event
                        }))"
                        required
                        [class.p-invalid-input]="streetName.invalid && streetName.touched"
                    >
                    <small class="field-error-message" *ngIf="streetName.invalid && streetName.touched">
                        Street name is required.
                    </small>
                </div>
            </div>
            <h6>Zip/Postal Code</h6>
            <div class="p-grid">
                <div
                    class="p-col-12"
                >
                    <input
                        type="text"
                        pInputText
                        placeholder="Area Code *"
                        (keydown.space)="$event.preventDefault();"
                        [ngModel]="viewModel.areaCode"
                        #areaCode="ngModel"
                        (ngModelChange)="store.dispatch(actions.areaCodeInputChanged({
                            areaCode: $event
                        }))"
                        required
                        [pattern]="viewModel.areaCodePattern"
                        [class.p-invalid-input]="areaCode.invalid && areaCode.touched"
                    >
                    <small class="field-error-message" *ngIf="areaCode.errors?.['required'] && areaCode.touched">
                        Area code is required.
                    </small>
                    <small class="field-error-message" *ngIf="areaCode.errors?.['pattern'] && areaCode.touched">
                        Invalid area code.
                    </small>
                    <br>
                </div>
            </div>

            <h6>Region</h6>
            <div class="p-grid">
                <div
                    class="p-col"
                >
                    <label>City</label>
                    <br />
                    <input
                        type="text"
                        pInputText
                        placeholder="City *"
                        [ngModel]="viewModel.city"
                        #city="ngModel"
                        (ngModelChange)="store.dispatch(actions.cityInputChanged({
                            city: $event
                        }))"
                        required
                        [class.p-invalid-input]="city.invalid && city.touched"
                    >
                    <small class="field-error-message" *ngIf="city.invalid && city.touched">
                        City is required.
                    </small>
                </div>
                <div
                    class="p-col"
                >
                    <label>Country</label>
                    <br />
                    <p-dropdown
                        class="full-width-dropdown"
                        placeholder="Select Country"
                        [options]="countries"
                        appendTo="body"
                        [ngModel]="viewModel.country"
                        #country="ngModel"
                        (onChange)="store.dispatch(actions.countrySelected({
                            country: $event.value
                        }))"
                        required
                        [class.p-invalid-input]="country.invalid && country.touched"
                    ></p-dropdown>
                    <small class="field-error-message" *ngIf="country.invalid && country.touched">
                        Country is required.
                    </small>
                </div>
                <div
                    class="p-col"
                >
                    <label>Jurisdiction</label>
                    <br />
                    <p-dropdown
                        class="full-width-dropdown"
                        placeholder="Select a Jurisdiction"
                        [options]="viewModel.country | jurisdiction"
                        appendTo="body"
                        [ngModel]="viewModel.jurisdiction"
                        #jurisdiction="ngModel"
                        (onChange)="store.dispatch(actions.jurisdictionSelected({
                            jurisdiction: $event.value
                        }))"
                        [class.p-invalid-input]="jurisdiction.invalid && jurisdiction.touched"
                    ></p-dropdown>
                    <small class="field-error-message" *ngIf="jurisdiction.invalid && jurisdiction.touched">
                        Jurisdiction is required.
                    </small>
                </div>
            </div>
        </div>
        <h6>Lookup Tools</h6>
        <ul>
            <li>
                <a
                    href="https://tools.usps.com/zip-code-lookup.htm"
                    target="_blank"
                >USPS Lookup</a>
            </li>
            <li>
                <a
                    href="https://www.canadapost-postescanada.ca/info/mc/personal/postalcode/fpc.jsf"
                    target="_blank"
                >Canada Post Lookup</a>
            </li>
        </ul>
    </div>
    <p-message
        severity="warn"
        text="The system will not be able to verify a manually entered location, ensure the values you have entered are correct before proceeding"
    ></p-message>
    <ng-template pTemplate="footer">
        <button
            pButton
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text discard-button"
            (click)="store.dispatch(actions.cancelButtonClicked())"
        ></button>
        <button
            pButton
            label="Add Location"
            icon="pi pi-plus"
            (click)="store.dispatch(actions.addLocationButtonClicked({
                locationType: viewModel.locationType,
                streetNumber: viewModel.streetNumber,
                streetName: viewModel.streetName,
                areaCode: viewModel.areaCode,
                city: viewModel.city,
                country: viewModel.country,
                jurisdiction: viewModel.jurisdiction,
            }))"
            [disabled]="!viewModel.canAddLocation"
        ></button>
    </ng-template>
</p-dialog>
